import React from 'react';
import PropTypes from 'prop-types';
import loader from '../../Asset/Images/loader.gif';

const Loader = ({ text = "Loading..." }) => {
    return (
        <div style={styles.container}>
            <div style={styles.content}>
                <img src={loader} alt="loading..." />
                <p style={styles.text}>{text}</p>
            </div>
        </div>
    );
};

Loader.propTypes = {
    text: PropTypes.string,
};

const styles = {
    container: {
        height: '100vh',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#f9f9f9', // Light background for contrast
        flexDirection: 'column',
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '1rem',
        textAlign: 'center',
    },
    text: {
        fontSize: '1.2rem',
        color: '#555',
        fontWeight: '500',
    }
};

export default Loader;
